module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("‘… we have to grope our way through so much filth and rubbish in order to reach home! And we have no one to show us the way. Homesickness is our only guide.’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('em', [_vm._v("Steppenwolf,")]), _vm._v(" Herman Hesse")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("‘That the soul should be open to the Divine Light, even with so small an opening as to allow only a glimmer to pass through, was enough to satisfy the utmost aspirations and capabilities of the vast majority for the rest of their life on earth. It remained for them to treasure what they had gained and to consolidate it …’")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—A Sufi Saint of the Twentieth Century,")]), _vm._v(" Martin Lings")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd337ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm.vue
// module id = 75
// module chunks = 0